import React from 'react'

import Alert from '@react/react-spectrum/Alert'
import Wait from '@react/react-spectrum/Wait'

import Picker from '../Picker'

import { useDsnApiV2 } from 'services/axios'

import { getUserId } from 'utils/user'

export default ({ value, disabled, onChange }) => {
  const [{ data, loading }] = useDsnApiV2('/dxa/projects', {})

  if (getUserId().includes('@')) {
    return (
      <div>
        <Alert variant='error'>Only users with @adobe.com email can set up and link DXA Survey.</Alert>
      </div>
    )
  }

  const options =
    data?.map((it) => ({
      label: (
        <div>
          {it.customer}
          <br />
          <small>({it.type})</small>
        </div>
      ),
      value: it.id,
    })) || []

  return (
    <div>
      <Picker
        placeholder={loading ? <Wait size='S' /> : 'Select Survey'}
        value={value}
        options={options}
        disabled={disabled || loading}
        onChange={onChange}
      />
    </div>
  )
}
